import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { I18nextProvider } from 'react-i18next';

import 'index.css';

import i18n from 'i18n';
import history from 'helpers/history';
import registerServiceWorker from 'helpers/registerServiceWorker';
import store from 'store';
import { authRequest } from 'store/auth';

import App from 'App';

store.dispatch(authRequest());

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ConnectedRouter history={history}>
        <Route path="/" component={App} />
      </ConnectedRouter>
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js